// Build-time environment. Only the public URL and anonymous key; the service-role key never reaches the browser.
export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
  environment: (import.meta.env.VITE_ENVIRONMENT as 'demo' | 'data' | undefined) ?? 'demo',
};
